import React from 'react';
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import Cleave from 'cleave.js/react';
import { Label, Col, Form, FormGroup, Input, Button, Row, FormFeedback } from 'reactstrap';
import { ButtonText, NewsLetterStyle } from '../../../../StyledComponents';
import { IoCaretBackOutline } from 'react-icons/io5';

const AddCreditCard = (props) => {
    const { name, onSwitchTab, onCancel } = props;

    const CreditCardSchema = yup.object().shape({
        cardNumber: yup
            .string()
            .matches(/^(?:\d{4} ){3}\d{4}$/, 'Card Number must be 16 digits')
            .required('Card Number is required'),
        cardHolderName: yup
            .string()
            .min(3, 'Name must be at least 3 characters')
            .max(50, 'Name must be at most 50 characters')
            .required('Card Holder Name is required'),
        expiry: yup
            .string()
            .matches(/^(0[1-9]|1[0-2])\/?([0-9]{2})$/, 'Invalid Expiry Date')
            .required('Expiry Date is required'),
        cvv: yup
            .string()
            .matches(/^[0-9]{3}$/, 'Invalid CVV/CVC')
            .required('CVV/CVC is required'),
    });

    const { control, handleSubmit, formState: { errors } } = useForm({
        mode: 'onChange',
        resolver: yupResolver(CreditCardSchema),
    });

    const onSubmit = (data) => {
        const formattedData = {
            ...data,
            cardNumber: data.cardNumber.replace(/\s/g, ''),
        };
        console.log(formattedData);
        onSwitchTab();
    };

    const formatCardNumber = (value) => {
        return value.replace(/\s?/g, '').replace(/(\d{4})/g, '$1 ').trim();
    };

    return (
        <>
         <Row className='m-0 p-0'>
            {
                name == "Reload Gift Card" ?
                <>
                    <Col  xl='1' lg='1' md='1' sm='12' xs='12'>
                        <NewsLetterStyle style={{ fontSize: '18px', cursor: 'pointer' }} onClick={() => onCancel(false)}> <IoCaretBackOutline /> Back</NewsLetterStyle>
                    </Col>
                </> : ""

            }
                <Col  xl='11' lg='11' md='11' sm='12' xs='12'>
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
                      <NewsLetterStyle style={{ fontWeight: '700' }}>Add Credit/Debit card</NewsLetterStyle>
                    </div>
            <div>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <Row className='w-100'>
                        <Col  xl="6" lg='6' md='6' sm="12" xs='12'>
                            <FormGroup>
                                <Label className='form-label' for='payment-card-number'>Card Number</Label>
                                <Controller
                                    name="cardNumber"
                                    control={control}
                                    id='payment-card-number'
                                    render={({ field }) => (
                                        <Input
                                            {...field}
                                            invalid={!!errors.cardNumber}
                                            placeholder='1234 5678 9123 4567'
                                            maxLength={19}
                                            onChange={(e) => {
                                                const formattedValue = formatCardNumber(e.target.value);
                                                field.onChange(formattedValue);
                                            }}
                                            value={field.value || ''} // Control the value
                                        />
                                    )}
                                />
                                {errors.cardNumber && <FormFeedback>{errors.cardNumber.message}</FormFeedback>}
                            </FormGroup>
                        </Col>
                        <Col  xl="6" lg='6' md='6' sm="12" xs='12'>
                            <FormGroup>
                                <Label className='form-label' for='payment-card-holder-name'>Card Holder Name</Label>
                                <Controller
                                    name="cardHolderName"
                                    control={control}
                                    id='payment-card-holder-name'
                                    render={({ field }) => (
                                        <Input
                                            {...field}
                                            invalid={!!errors.cardHolderName}
                                            placeholder='Enter Holder Name'
                                        />
                                    )}
                                />
                                {errors.cardHolderName && <FormFeedback>{errors.cardHolderName.message}</FormFeedback>}
                            </FormGroup>
                        </Col>
                        <Col  xl="6" lg='6' md='6' sm="12" xs='12'>
                            <FormGroup>
                                <Label className='form-label' for='payment-expiry'>Expiry</Label>
                                <Controller
                                    name="expiry"
                                    control={control}
                                    id='payment-expiry'
                                    render={({ field }) => (
                                        <Cleave
                                            {...field}
                                            className={`form-control ${errors.expiry ? 'is-invalid' : ''}`}
                                            placeholder='MM/YY'
                                            options={{ date: true, delimiter: '/', datePattern: ['m', 'y'] }}
                                        />
                                    )}
                                />
                                {errors.expiry && <FormFeedback>{errors.expiry.message}</FormFeedback>}
                            </FormGroup>
                        </Col>
                        <Col  xl="6" lg='6' md='6' sm="12" xs='12'>
                            <FormGroup>
                                <Label className='form-label' for='payment-cvv'>CVV/CVC</Label>
                                <Controller
                                    name="cvv"
                                    id='payment-cvv'
                                    control={control}
                                    render={({ field }) => (
                                        <Input
                                            {...field}
                                            invalid={!!errors.cvv}
                                            placeholder='123'
                                            type='text'
                                            onChange={(e) => {
                                                const value = e.target.value.replace(/[^0-9]/g, ''); // Allow only numbers
                                                field.onChange(value);
                                            }}
                                            value={field.value || ''} // Control the value
                                            maxLength='3'
                                        />
                                    )}
                                />
                                {errors.cvv && <FormFeedback>{errors.cvv.message}</FormFeedback>}
                            </FormGroup>
                        </Col>
                        <Col className='mb-2 d-flex justify-content-end'>
                        <button type='submit' className='btn' style={{ backgroundColor: '#41B8E4', color: 'white' }}>Add Card</button>
                        </Col>
                    </Row>
                </Form>
            </div>
        
            </Col>
            </Row>
        </>
    );
};

export default AddCreditCard;
